/**
 * BPMN 基础属性组件
 * 适用于所有BPMN元素的通用属性配置
 */
import React from 'react';
import { Form, Input, Card } from 'antd';
import { SettingOutlined } from '@ant-design/icons';

const { TextArea } = Input;

const BasicProperties = () => {
  return (
    <Card 
      size="small" 
      className="mb-4"
      title={
        <div className="flex items-center space-x-2">
          <SettingOutlined />
          <span>基础属性</span>
        </div>
      }
    >
      <Form.Item
        label="元素ID"
        name="id"
        rules={[{ required: true, message: '请输入元素ID' }]}
        className="mb-3"
      >
        <Input disabled className="bg-gray-50" />
      </Form.Item>
      
      <Form.Item
        label="名称"
        name="name"
        rules={[{ required: true, message: '请输入元素名称' }]}
        className="mb-3"
      >
        <Input placeholder="请输入元素名称" />
      </Form.Item>
      
      <Form.Item
        label="文档说明"
        name="documentation"
        className="mb-0"
      >
        <TextArea 
          rows={3} 
          placeholder="请输入文档说明" 
        />
      </Form.Item>
    </Card>
  );
};

export default BasicProperties;